var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 81,
    viewBox: "0 0 393 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.048 44.2465H162.015C163.197 47.7207 166.768 50.5208 171.573 50.5208C177.297 50.5208 181.656 46.3985 182.234 40.9279H168.028V38.3092H182.207C181.498 32.9942 177.192 29.0014 171.573 29.0014C166.768 29.0014 163.197 31.8016 162.015 35.2758H159.048C160.098 30.8423 164.693 26.3828 171.547 26.3828C179.109 26.3828 185.096 32.1905 185.096 39.7611C185.096 47.3577 179.109 53.1395 171.547 53.1395C164.693 53.1395 160.098 48.706 159.048 44.2465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.076 40.2279V52.7247H191.319V26.8496H194.076V38.1797L206.155 26.8496H209.962L196.939 39.139L213.008 52.7507H208.833L194.076 40.2279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.29 26.4346C220.728 26.4346 214.741 32.2163 214.741 39.8129C214.741 47.3836 220.728 53.1912 228.29 53.1912C235.17 53.1912 239.739 48.7577 240.815 44.2983H237.848C236.666 47.7725 233.095 50.5726 228.29 50.5726C222.198 50.5726 217.577 45.8539 217.577 39.8129C217.577 33.7978 222.198 29.0532 228.29 29.0532C233.095 29.0532 236.666 31.8533 237.848 35.3275H240.815C239.739 30.894 235.17 26.4346 228.29 26.4346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.105 29.4942H249.295V52.7507H246.591V26.8496H266.836V52.7507H264.105V29.4942Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.732 43.0021H282.721C288.183 43.0021 291.649 39.502 291.649 34.9388C291.649 30.3757 288.183 26.8496 282.721 26.8496H274.923V52.7507H277.732V43.0021ZM277.732 29.4423H282.721C286.713 29.4423 288.813 31.8535 288.813 34.9388C288.813 38.0501 286.713 40.4094 282.721 40.4094H277.732V29.4423Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.269 26.8496H312.236V29.4942H300.078V38.1278H310.004V40.7465H300.078V50.1061H312.236V52.7247H297.269V26.8496Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M330.169 26.4346C322.607 26.4346 316.62 32.2163 316.62 39.8129C316.62 47.3836 322.607 53.1912 330.169 53.1912C337.049 53.1912 341.618 48.7577 342.694 44.2983H339.727C338.545 47.7725 334.974 50.5726 330.169 50.5726C324.077 50.5726 319.456 45.8539 319.456 39.8129C319.456 33.7978 324.077 29.0532 330.169 29.0532C334.974 29.0532 338.545 31.8533 339.727 35.3275H342.694C341.618 30.894 337.049 26.4346 330.169 26.4346Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346.606 39.8129C346.606 32.2163 352.593 26.4346 360.156 26.4346C367.035 26.4346 371.604 30.894 372.68 35.3275H369.713C368.532 31.8533 364.961 29.0532 360.156 29.0532C354.064 29.0532 349.442 33.7978 349.442 39.8129C349.442 45.8539 354.064 50.5726 360.156 50.5726C364.961 50.5726 368.532 47.7725 369.713 44.2983H372.68C371.604 48.7577 367.035 53.1912 360.156 53.1912C352.593 53.1912 346.606 47.3836 346.606 39.8129Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5153 44.6355C90.5153 39.839 86.7079 36.5463 81.5876 36.5463H76.3623V31.8794H88.2571V26.8496H70.9795V52.7247H81.5876C86.7079 52.7247 90.5153 49.3802 90.5153 44.6355ZM76.3623 41.3947H81.5089C83.767 41.3947 85.29 42.5614 85.29 44.6355C85.29 46.7097 83.7408 47.8505 81.4826 47.8505H76.3623V41.3947Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7054 41.0057V52.7507H94.4014V26.8496H99.7317V37.8167L109.185 26.8496H115.801L105.01 39.2946L118.033 52.7507H111.101L99.7054 41.0057Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.134 26.4346C124.204 26.4346 118.401 32.3459 118.401 39.8129C118.401 47.2799 124.204 53.1912 132.134 53.1912C138.095 53.1912 143.373 49.4318 144.843 43.9353H139.04C137.963 46.528 135.049 48.0836 132.134 48.0836C127.119 48.0836 123.784 44.4538 123.784 39.8129C123.784 35.1979 127.119 31.5422 132.134 31.5422C135.049 31.5422 137.963 33.0978 139.04 35.6905H144.843C143.373 30.194 138.068 26.4346 132.134 26.4346Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3645 60C51.4233 60 60.3882 51.0457 60.3882 40C60.3882 28.9543 51.4233 20 40.3645 20C29.3057 20 20.3408 28.9543 20.3408 40C20.3408 51.0457 29.3057 60 40.3645 60Z",
    fill: "url(#paint0_linear_3_859)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4243 23.4152C22.7672 29.4636 23.4896 40.3612 31.04 47.7531C38.5877 55.145 50.1024 56.2366 56.7622 50.1856C57.5167 49.5 58.1764 48.7523 58.7422 47.9545C59.8014 45.5167 60.3886 42.8268 60.3886 40C60.3886 28.9543 51.4237 20 40.3649 20C36.6428 20 33.1578 21.0144 30.1721 22.7815C29.9166 22.9832 29.6672 23.1944 29.4243 23.4152Z",
    fill: "url(#paint1_radial_3_859)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7837 23.414C27.6328 28.207 31.3022 35.6557 38.9806 40.0465C46.659 44.4399 55.435 44.1139 58.5885 39.3182C59.4791 37.9639 59.8255 36.398 59.6912 34.7492C57.3822 26.2506 49.6043 20 40.3647 20C37.5744 20 34.9174 20.5701 32.5041 21.5999C31.8244 22.1088 31.244 22.7137 30.7837 23.414Z",
    fill: "url(#paint2_radial_3_859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_859",
    x1: 51.1834,
    y1: 84.859,
    x2: 37.5817,
    y2: -5.57742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303516,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733277,
    stopColor: "white",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3_859",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3103 41.7105) rotate(106.278) scale(36.1876 30.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279744,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.450971,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3_859",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.1002 12.6694) rotate(53.1036) scale(50.7038 56.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136507,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397079,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725487,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.6b6f60d0e0a5d9509e00db6e30391421.svg";
export { ForwardRef as ReactComponent };